import React from "react";
import "../App.css";
import Header from "./Header";
import TournamentBanner from "./TournamentBanner";
import TournamentCards from "./TournamentCards";
import Footer from "./Footer";

export default function Tournament() {
  return (
    <>
      <Header link={"tournament"} />
      <TournamentBanner />
      <TournamentCards />
      <Footer />
    </>
  );
}
